let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ay8u5")).then(() => parcelRequire('dWAhE'));